

import '../styles/MediumPopup.css'
import { Typewriter,Cursor } from 'react-simple-typewriter';
import react,{useState} from 'react';
const MediumPopup = ()=>{
    const [display,setDisplay] = useState(false)
    
    
  const animationend = ()=>{
    setDisplay(true)
  }
   
   
          return(
          <div className='Mediumpopup'>
                <div className='circle-medium ui-shadow'>
                    <div className='middle-circle-medium'>
                        </div>
                    </div>
                <div className='lines'>
                    <div className='first-line-medium ui-shadow'></div>
                    <div className='second-line-medium ui-shadow'></div>
                    <div className='third-line-medium ui-shadow'></div>
                    
                </div>
                <div onAnimationEnd={animationend} className='label-container-medium'>
                    <div className='label-medium'>
                       <p>
                       { display && <Typewriter words={["Mohamed Chibani"]} loop={1}  typeSpeed={20}/>}
                      
                       </p>
                    </div>
                </div>
                </div>
          )
}
export default MediumPopup;